/* Rahul Ecommerce theme scripts */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };

  function toast(msg) {
    var t = $('[data-toast]');
    if (!t) return;
    t.textContent = msg; t.classList.add('is-show');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { t.classList.remove('is-show'); }, 2600);
  }

  /* Wishlist (stored in this browser only) */
  var wish = [];
  try { wish = JSON.parse(localStorage.getItem('rahul_wish') || '[]'); } catch (e) { wish = []; }
  function paintWish() {
    $$('[data-wish]').forEach(function (b) { b.classList.toggle('is-on', wish.indexOf(b.getAttribute('data-wish')) > -1); });
    $$('[data-wish-count]').forEach(function (c) { c.textContent = wish.length; });
  }
  paintWish();

  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-wish]'))) {
      e.preventDefault();
      var h = t.getAttribute('data-wish'), i = wish.indexOf(h);
      if (i > -1) wish.splice(i, 1); else wish.push(h);
      try { localStorage.setItem('rahul_wish', JSON.stringify(wish)); } catch (err) { /* ignore */ }
      paintWish();
    }
    if (e.target.closest('[data-drawer-open]')) { $('[data-drawer]').classList.add('is-open'); document.body.classList.add('no-scroll'); }
    if (e.target.closest('[data-drawer-close]')) { $('[data-drawer]').classList.remove('is-open'); document.body.classList.remove('no-scroll'); }
    if (e.target.closest('[data-search-toggle]')) {
      var bar = $('[data-search-bar]'); bar.classList.toggle('is-open');
      if (bar.classList.contains('is-open')) { var inp = $('input', bar); if (inp) inp.focus(); }
    }
    if ((t = e.target.closest('[data-qty-minus],[data-qty-plus]'))) {
      var wrap = t.closest('[data-qty-wrap]'), input = $('[data-qty]', wrap);
      var v = parseInt(input.value, 10) || 1;
      v = t.hasAttribute('data-qty-plus') ? v + 1 : Math.max(1, v - 1);
      input.value = v;
    }
    if ((t = e.target.closest('[data-tab]'))) {
      var box = t.closest('[data-tabs]');
      $$('[data-tab]', box).forEach(function (b) { b.classList.toggle('is-active', b === t); b.setAttribute('aria-selected', b === t); });
      $$('[data-panel]', box).forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== t.getAttribute('data-tab'); });
    }
    if ((t = e.target.closest('[data-video-play]'))) {
      var vb = t.closest('[data-video]'), tpl = $('[data-video-template]', vb);
      if (tpl) { vb.innerHTML = ''; vb.appendChild(tpl.content.cloneNode(true)); vb.classList.add('is-playing'); }
    }
    if ((t = e.target.closest('[data-thumb]'))) {
      var g = t.closest('[data-gallery]'), sl = $('[data-slider]', g);
      if (sl && sl._slider) { sl._slider.goTo(parseInt(t.getAttribute('data-thumb'), 10)); sl._slider.restart(); }
    }
    if ((t = e.target.closest('[data-zoom]'))) { openZoom(t.getAttribute('data-zoom'), t.getAttribute('data-zoom-alt')); }
    if (e.target.closest('[data-zoom-close]')) closeZoom();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeZoom();
      var d = $('[data-drawer]'); if (d) { d.classList.remove('is-open'); document.body.classList.remove('no-scroll'); }
    }
  });

  /* Tap-to-zoom lightbox */
  var zoomEl;
  function openZoom(src, alt) {
    if (!zoomEl) {
      zoomEl = document.createElement('div');
      zoomEl.className = 'zoom';
      zoomEl.innerHTML = '<button type="button" class="zoom__close" data-zoom-close aria-label="Close">&times;</button><div class="zoom__stage"><img alt=""></div>';
      document.body.appendChild(zoomEl);
      var img = $('img', zoomEl), stage = $('.zoom__stage', zoomEl);
      stage.addEventListener('click', function (e) {
        if (!zoomEl.classList.contains('is-zoomed')) { setOrigin(e); zoomEl.classList.add('is-zoomed'); }
        else zoomEl.classList.remove('is-zoomed');
      });
      stage.addEventListener('mousemove', function (e) { if (zoomEl.classList.contains('is-zoomed')) setOrigin(e); });
      stage.addEventListener('touchmove', function (e) { if (zoomEl.classList.contains('is-zoomed') && e.touches[0]) setOrigin(e.touches[0]); }, { passive: true });
      function setOrigin(e) {
        var r = img.getBoundingClientRect();
        var x = Math.max(0, Math.min(100, (e.clientX - r.left) / r.width * 100));
        var y = Math.max(0, Math.min(100, (e.clientY - r.top) / r.height * 100));
        img.style.transformOrigin = x + '% ' + y + '%';
      }
    }
    var im = $('img', zoomEl); im.src = src; im.alt = alt || ''; im.style.transformOrigin = '50% 50%';
    zoomEl.classList.remove('is-zoomed'); zoomEl.classList.add('is-open'); document.body.classList.add('no-scroll');
  }
  function closeZoom() {
    if (zoomEl) { zoomEl.classList.remove('is-open', 'is-zoomed'); document.body.classList.remove('no-scroll'); }
  }

  /* AJAX add to cart */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form[data-ajax-cart]')) return;
    if (e.submitter && e.submitter.name === 'checkout') return;
    e.preventDefault();
    var btn = e.submitter || $('[type=submit]', f);
    if (btn) btn.disabled = true;
    fetch(window.theme.routes.add, { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { return fetch(window.theme.routes.cart, { headers: { Accept: 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; });
        toast(window.theme.strings.added);
      })
      .catch(function () { toast(window.theme.strings.error); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  /* Variant picker */
  function initProduct(root) {
    var vjson = $('[data-variants]', root);
    if (!vjson || root._pinit) return;
    root._pinit = true;
    var variants = JSON.parse(vjson.textContent);
    function update() {
      var opts = $$('[data-option]:checked', root).map(function (i) { return i.value; }).join('|');
      var v = variants.filter(function (x) { return x.options.join('|') === opts; })[0];
      var add = $('[data-add]', root), buy = $('[data-buy]', root), stock = $('[data-stock]', root);
      if (!v) { if (add) { add.disabled = true; } if (buy) buy.disabled = true; if (stock) { stock.textContent = 'Unavailable'; stock.className = 'stock is-out'; } return; }
      $('[data-variant-id]', root).value = v.id;
      var p = $('[data-price]', root), c = $('[data-compare]', root), sv = $('[data-save]', root);
      if (p) p.textContent = v.price;
      if (c) { c.textContent = v.compare || ''; c.hidden = !v.compare; }
      if (sv) { sv.textContent = 'Save ' + v.pct + '%'; sv.hidden = !v.compare; }
      if (add) { add.disabled = !v.available; $('span', add).textContent = v.available ? add.getAttribute('data-label') : 'Sold Out'; }
      if (buy) buy.disabled = !v.available;
      if (stock) { stock.textContent = v.available ? 'In Stock' : 'Out of Stock'; stock.className = 'stock ' + (v.available ? 'is-in' : 'is-out'); }
      var names = $$('[data-option-value]', root);
      names.forEach(function (n) {
        var idx = parseInt(n.getAttribute('data-option-value'), 10);
        var chk = $$('[data-option]:checked', root)[idx];
        if (chk) n.textContent = chk.value;
      });
      if (v.mediaIndex > -1) {
        var sl = $('[data-slider]', root);
        if (sl && sl._slider) { sl._slider.goTo(v.mediaIndex); }
      }
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      }
    }
    root.addEventListener('change', function (e) { if (e.target.matches('[data-option]')) update(); });

    var gal = $('[data-gallery]', root);
    if (gal) {
      var sl2 = $('[data-slider]', gal);
      if (sl2) sl2.addEventListener('slider:change', function (e) {
        $$('[data-thumb]', gal).forEach(function (t) { t.classList.toggle('is-active', parseInt(t.getAttribute('data-thumb'), 10) === e.detail.index); });
        var active = $('[data-thumb].is-active', gal);
        var col = $('.pdp__thumbs', gal);
        if (active && col) { col.scrollTop = active.offsetTop - col.offsetTop - 8; col.scrollLeft = active.offsetLeft - col.offsetLeft - 8; }
      });
    }
  }
  $$('[data-product]').forEach(initProduct);
  document.addEventListener('shopify:section:load', function (e) { $$('[data-product]', e.target).forEach(initProduct); paintWish(); });
})();
